export default "__VITE_ASSET__B$023m0U__"